import React from 'react';

export const Facade = ({ pageSize, colSpan }) =>
	new Array(pageSize).fill().map((v, rowIndex) => (
		<tr key={rowIndex} data-facade={true}>
			{new Array(colSpan).fill().map((v, cellIndex) => (
				<td key={cellIndex}>
					<div
						className='rt-facade'
						style={{ width: `${30 + Math.round(Math.random() * 60)}%` }}>
						.
					</div>
				</td>
			))}
		</tr>
	));
